import Color from './Color'
export const scrollBar = {
  overflow: 'auto !important',
  transition: '0.3s',
  '&::-webkit-scrollbar': {
    opacity: 0,
    width: '0.58em',
    height: '8px'
  },
  '&:hover': {
    '&::-webkit-scrollbar': {
      opacity: 1
    },
    '&::-webkit-scrollbar-track': {
      '-webkit-box-shadow': `inset 0 0 12px ${Color.primary[500]}`
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '8px',
      outline: '1px solid beige',
      backgroundColor: Color.primary[600]
    }
  }
}
